define('controllers/memberservices/commodityMain.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('CommodityMain', ['$scope', '$state','$rootScope', 'paidMemberService',
        function ($scope, $state,$rootScope,paidMemberService) {

            $rootScope.checkState($state).then(function () {
                init();
            });
            function init() {
                //查询自己购买的套餐，如果有则调整到我的套餐界面，没有则调整到会员市场页面
                if($state.$current.name =='memberservices'){
                    paidMemberService.getUserSubscriptionList().then(function(u){
                        if(u && u.userSubscriptionList && u.userSubscriptionList.length > 0 ){
                            $state.go('memberservices.myCommodityList');
                        }else{
                            $state.go('memberservices.commodityList');
                        }
                    });
                }
            }
        }
    ]);
});

